<template>
  <div class="category-list-table">
    <el-table
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->

      <!-- Name -->
      <el-table-column
        :label="fields.name.label" 
        :prop="fields.name.name" 
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tooltip
            :disabled="!hasPermissionToAuditLogs"
            effect="dark"
            :content="scope.row.id"
            placement="bottom"
          >
            <span
              v-text="presenter(scope.row, 'name')"
            />
          </el-tooltip>
        </template>
      </el-table-column>

      <!-- Shortname -->
      <el-table-column :label="fields.label.label" :prop="fields.label.name">
        <template slot-scope="scope">{{ presenter(scope.row, 'label') }}</template>
      </el-table-column>

      <!-- Born form -->
      <el-table-column :label="fields.minBirthDate.label" :prop="fields.minBirthDate.name">
        <template slot-scope="scope">{{ presenter(scope.row, 'minBirthDate') }}</template>
      </el-table-column>

      <!-- Born until -->
      <el-table-column :label="fields.maxBirthDate.label" :prop="fields.maxBirthDate.name">
        <template slot-scope="scope">{{ presenter(scope.row, 'maxBirthDate') }}</template>
      </el-table-column>

      <!-- Buttons actions -->
      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link
              :to="`/subproperty/settings/program/category/${scope.row.id}/edit`"
              v-if="hasPermissionToEdit"
            >
              <el-button icon="icon-pen" circle />
            </router-link>

            <el-button
              v-if="hasPermissionToDestroy"
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              circle
              icon="icon-trash"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { CategoryModel } from '@modules/category/category-model';
import { mapGetters, mapActions } from 'vuex';
import { CategoryPermissions } from '@modules/category/category-permissions';
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-category-list-table',

  mounted() {
    // this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'category/list/rows',
      count: 'category/list/count',
      loading: 'category/list/loading',
      pagination: 'category/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      currentManage: 'auth/manage/currentManage',
      destroyLoading: 'category/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
      populateDate: 'auth/manage/populateDate',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new CategoryPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new CategoryPermissions(this.currentUser)
        .destroy;
    },

    fields() {
      const { dateFormat, timeFormat, populateDate } = this;
      return new CategoryModel({ dateFormat, timeFormat, populateDate }).fields();
    },

    isAdmin() {
      if (this.currentUser && this.currentUser.isAdmin) {
        return this.currentUser.isAdmin;
      }
      return false;
    },

    // isDisabledRemove(){
    //   const isDisabledForNormalUsers = process.env.VUE_APP_DISABLE_REMOVE_BUTTON_CATEGORY_NORMAL_USERS === 'true' && !this.isAdmin;
    //   return isDisabledForNormalUsers;
    // }
  },

  methods: {
    ...mapActions({
      doChangeSort: 'category/list/doChangeSort',
      doChangePaginationCurrentPage:
        'category/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'category/list/doChangePaginationPageSize',
      doMountTable: 'category/list/doMountTable',
      doDestroy: 'category/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      const { dateFormat, populateDate } = this;
      return new CategoryModel({ dateFormat, populateDate }).presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy({
          id,
          manage: this.currentManage,
        });
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
.category-list-table .el-table__row {
  cursor: default;
}
</style>
